import React, { useMemo } from "react";
import classnames from "classnames";
import "./styles.less";

export const Column = (props) => {
  return <span {...props}></span>;
};

export const Table = (props) => {
  const { data, children } = props;
  const columns = useMemo(() => {
    return (children || []).map((child) => {
      return child.props;
    });
  }, [children]);

  return (
    <table className="normal-table">
      <thead>
        <tr>
          {columns.map((column) => {
            if (column.title) {
              return (
                <th key={column.key || column.dataIndex}>{column.title}</th>
              );
            } else {
              return <></>;
            }
          })}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => {
          const cls = classnames({ even: index % 2 });
          return (
            <>
              <tr className={cls}>
                {columns.map((column) => {
                  const value = item[column.dataIndex];
                  console.log(value);
                  if (value || column.render) {
                    return (
                      <>
                        <td key={column.key || column.dataIndex}>
                          {column.render ? column.render(value, item) : value}
                        </td>
                      </>
                    );
                  } else {
                    return <></>;
                  }
                })}
              </tr>
            </>
          );
        })}
      </tbody>
    </table>
  );
};
